function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Path_244",
  "data-name": "Path 244",
  d: "M542.195,112.693h14.967v.245H571.14c0,.084.079.167.079.245v23.051a.472.472,0,0,1-.492.492H542.195c-.246,0-.414-.162-.414-.492V113.184a.461.461,0,0,1,.414-.491m28.036.9H542.691v22.229H570.23Z",
  transform: "translate(-541.771 -84.804)",
  fill: "#707070"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_273",
  "data-name": "Rectangle 273",
  width: 29.933,
  height: 25.253,
  transform: "translate(0 26.67)",
  fill: "none"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  id: "Path_245",
  "data-name": "Path 245",
  d: "M546.251,108.349h10.91v.9H546.413l-3.142,3.2h13.89v.245h13.979a.517.517,0,0,1-.084.576.5.5,0,0,1-.329.083H542.195a.392.392,0,0,1-.413-.413.412.412,0,0,1,.167-.325l3.968-4.1c.083-.167.167-.167.334-.167",
  transform: "translate(-541.771 -84.561)",
  fill: "#707070"
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_274",
  "data-name": "Rectangle 274",
  width: 29.933,
  height: 6.293,
  transform: "translate(0 22.895)",
  fill: "none"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  id: "Path_248",
  "data-name": "Path 248",
  d: "M560.768,137.684h-7.361c-.245,0-.413-.162-.413-.492V130.22a.388.388,0,0,1,.413-.408c.167,0,.251,0,.329.078l3.309,2.3,3.471-2.3a.524.524,0,0,1,.664.083c0,.084.084.162.084.246v6.972a.476.476,0,0,1-.5.492m-6.864-.9h6.367v-5.659l-2.975,2.05a.554.554,0,0,1-.5,0l-2.9-2.05Z",
  transform: "translate(-542.399 -85.762)",
  fill: "#707070"
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_276",
  "data-name": "Rectangle 276",
  width: 10.07,
  height: 8.89,
  transform: "translate(9.794 43.033)",
  fill: "none"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  id: "Path_249",
  "data-name": "Path 249",
  d: "M587.306,112.693h15.212a.529.529,0,0,1,.5.491v23.051a.473.473,0,0,1-.5.492H574.075a.476.476,0,0,1-.5-.492V113.184a.3.3,0,0,1,.084-.245h13.644Zm14.8.9H574.488v22.229h27.618Z",
  transform: "translate(-543.551 -84.804)",
  fill: "#707070"
});

var _ref9 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_277",
  "data-name": "Rectangle 277",
  width: 29.541,
  height: 25.253,
  transform: "translate(29.934 26.67)",
  fill: "none"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  id: "Path_250",
  "data-name": "Path 250",
  d: "M587.306,108.349h11.5a.433.433,0,0,1,.329.167l3.722,4.1a.5.5,0,0,1,0,.654c-.084.083-.167.083-.334.083H574.075a.466.466,0,0,1-.5-.413.3.3,0,0,1,.084-.246h13.644v-.245h14.225l-2.98-3.2H587.306Z",
  transform: "translate(-543.551 -84.561)",
  fill: "#707070"
});

var _ref11 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_278",
  "data-name": "Rectangle 278",
  width: 29.541,
  height: 6.293,
  transform: "translate(29.934 22.895)",
  fill: "none"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  id: "Path_253",
  "data-name": "Path 253",
  d: "M592.565,137.684h-7.277a.473.473,0,0,1-.5-.492V130.22a.459.459,0,0,1,.5-.408.31.31,0,0,1,.245.078l3.309,2.3,3.471-2.3a.511.511,0,0,1,.664.083.3.3,0,0,1,.084.246v6.972a.476.476,0,0,1-.5.492m-6.864-.9h6.451v-5.659l-2.979,2.05a.744.744,0,0,1-.58,0l-2.892-2.05Z",
  transform: "translate(-544.178 -85.762)",
  fill: "#707070"
});

var _ref13 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_280",
  "data-name": "Rectangle 280",
  width: 10.07,
  height: 8.89,
  transform: "translate(40.004 43.033)",
  fill: "none"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  id: "Path_254",
  "data-name": "Path 254",
  d: "M561.928,83.151h20.754c.167,0,.251,0,.329.167l3.805,4.1a.426.426,0,0,1-.083.653.3.3,0,0,1-.246.084H557.961a.459.459,0,0,1-.5-.413c0-.162.083-.245.161-.408l3.973-4.1a.485.485,0,0,1,.329-.083m20.587.9H562.1l-3.063,3.2h26.379Z",
  transform: "translate(-542.649 -83.15)",
  fill: "#707070"
});

var _ref15 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_281",
  "data-name": "Rectangle 281",
  width: 31.468,
  height: 5.271,
  transform: "translate(13.571)",
  fill: "none"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  id: "Path_256",
  "data-name": "Path 256",
  d: "M571.4,83.151h3.309a.455.455,0,0,1,.413.245l1.82,4.1a.551.551,0,0,1-.246.659h-7.528a.463.463,0,0,1-.5-.413c0-.162,0-.245.084-.245l2.232-4.1a.462.462,0,0,1,.413-.245m2.979.9h-2.729l-1.735,3.2h5.871Z",
  transform: "translate(-543.276 -83.15)",
  fill: "#707070"
});

var _ref17 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_283",
  "data-name": "Rectangle 283",
  width: 8.812,
  height: 5.271,
  transform: "translate(24.899)",
  fill: "none"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  id: "Path_246",
  "data-name": "Path 246",
  d: "M553.408,112.693h4.381v.245h3.393c0,.084.083.167.083.246v6.972a.466.466,0,0,1-.5.413.485.485,0,0,1-.329-.083l-3.309-2.3-3.393,2.3a.425.425,0,0,1-.659-.084.293.293,0,0,1-.083-.245v-6.972a.461.461,0,0,1,.413-.492m6.864.9H553.9v5.659l2.975-1.967a.309.309,0,0,1,.5,0l2.9,1.967Z",
  transform: "translate(-542.399 -84.804)",
  fill: "#707070"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  id: "Path_247",
  "data-name": "Path 247",
  d: "M555.723,108.349h2.066v.9h-1.82l-1.735,3.2h3.555v.245h3.392v.084c.167.162,0,.492-.245.575h-7.528a.392.392,0,0,1-.413-.413.3.3,0,0,1,.084-.246l2.233-4.1a.457.457,0,0,1,.413-.245",
  transform: "translate(-542.399 -84.561)",
  fill: "#707070"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  id: "Path_251",
  "data-name": "Path 251",
  d: "M587.934,112.693h4.631a.534.534,0,0,1,.5.492v6.972a.467.467,0,0,1-.5.413.307.307,0,0,1-.25-.083l-3.388-2.3-3.392,2.3a.425.425,0,0,1-.659-.084.291.291,0,0,1-.084-.245v-6.972a.3.3,0,0,1,.084-.246h3.058Zm4.219.9H585.7v5.659l2.975-1.967a.4.4,0,0,1,.58,0l2.9,1.967Z",
  transform: "translate(-544.179 -84.804)",
  fill: "#707070"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  id: "Path_252",
  "data-name": "Path 252",
  d: "M587.934,108.349h2.9a.425.425,0,0,1,.413.329l1.819,4.1a.454.454,0,0,1-.25.575H585.2a.389.389,0,0,1-.413-.413.3.3,0,0,1,.083-.246h3.059v-.245H591.9l-1.406-3.2h-2.562Z",
  transform: "translate(-544.179 -84.561)",
  fill: "#707070"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  id: "Path_255",
  "data-name": "Path 255",
  d: "M569.169,87.5h7.361a.458.458,0,0,1,.413.492v6.972a.387.387,0,0,1-.413.413c-.167,0-.245,0-.329-.083l-3.309-2.3-3.471,2.3a.517.517,0,0,1-.664-.078c0-.084-.084-.168-.084-.251V87.987a.533.533,0,0,1,.5-.492m6.864.9h-6.451v5.659l3.063-2.05a.513.513,0,0,1,.5,0l2.892,2.05Z",
  transform: "translate(-543.276 -83.394)",
  fill: "#707070"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  id: "Path_257",
  "data-name": "Path 257",
  d: "M576.528,112.486h-7.36a.534.534,0,0,1-.5-.492v-6.972a.462.462,0,0,1,.5-.408c.083,0,.25,0,.25.083l3.388,2.3,3.392-2.3a.5.5,0,0,1,.659.078.3.3,0,0,1,.084.246v6.972a.458.458,0,0,1-.413.492m-6.947-.9h6.451v-5.659l-2.975,1.967c-.167.167-.413.167-.5,0l-2.979-1.967Z",
  transform: "translate(-543.276 -84.352)",
  fill: "#707070"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  id: "Path_258",
  "data-name": "Path 258",
  d: "M558.049,87.755h28.365a.354.354,0,0,1,.329.329v23.458a.351.351,0,0,1-.329.329H558.049a.377.377,0,0,1-.414-.329V88.084a.381.381,0,0,1,.414-.329m28.036.659h-27.7v22.8h27.7Z",
  transform: "translate(-542.659 -83.408)",
  fill: "#fff"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  id: "Path_259",
  "data-name": "Path 259",
  d: "M557.7,87.755h28.862a.358.358,0,0,1,.329.329v23.458a.354.354,0,0,1-.329.329H557.7a.354.354,0,0,1-.329-.329V88.084a.358.358,0,0,1,.329-.329m28.444.659H558.117v22.8h28.031Z",
  transform: "translate(-542.644 -83.408)",
  fill: "#707070"
});

function SvgPicker(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_141_1",
    "data-name": "Component 141 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 59.474,
    height: 51.923,
    viewBox: "0 0 59.474 51.923",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPicker);
export default __webpack_public_path__ + "static/media/picker.d54a1b14c0374e29fbf500552613f143.svg";
export { ForwardRef as ReactComponent };